<div class="login-wrapper">
  <img *ngIf="backgroundImagePath" class="app-background" [src]="backgroundImagePath">
  <div class="login-container">
    <div class="login-header">
      <eidos-icon id="mainLogo" class="app-logo" [iconConfiguration]="logo"></eidos-icon>
    </div>
    <div class="mat-card auth-block">
      <div class="mat-card-content" [ngSwitch]="status">
        <content *ngSwitchCase="EidosResetCredentialsStatus.Entered">
          <p class="reset-credentials-message">Redirecting to login in {{ timeout }} seconds...</p>
        </content>
        <content *ngSwitchCase="EidosResetCredentialsStatus.Requested">
          <div class="reset-credentials-icon">
            <eidos-progress-spinner class="request-spinner" style="margin:0 auto;"></eidos-progress-spinner>
          </div>
          <p class="reset-credentials-message">Submitting request...</p>
        </content>
        <content *ngSwitchCase="EidosResetCredentialsStatus.Ok">
          <div class="reset-credentials-icon">
            <eidos-icon [iconConfiguration]="okIcon"></eidos-icon>
          </div>
          <p class="reset-credentials-message">Your request has been confirmed. Check your inbox for further details.</p>
          <button class="eidos-button eidos-button-normal eidos-button-success" type="button" (click)="goToLogin()">Go to login</button>
        </content>
        <content *ngSwitchCase="EidosResetCredentialsStatus.Error">
          <div class="reset-credentials-icon">
            <eidos-icon [iconConfiguration]="clearIcon"></eidos-icon>
          </div>
          <p class="reset-credentials-message">Server error.  Redirecting to login in {{ timeout }} seconds...</p>
        </content>
      </div>
    </div>
  </div>
</div>